module.exports = __webpack_public_path__ + "static/media/heading.95b984f4.svg";